<template>
    <div class="page-section">
        <a-card :bordered="false" style="width: 100%" id="title-card">
            <template slot="title">
                <div class="v2-tab-hd">
                    <h2>{{ title }}</h2>
                    <div class="v2-tab-sub">{{ subtitle }}</div>
                </div>
            </template>
            <template slot="extra">
                <div class="title-actions">
                    <a-button type="default" @click="showAddProvider = true">
                        <i class="fa-solid fa-plus"></i> Novo Fornecedor
                    </a-button>
                    <a-button
                        v-if="showProviderFilters && can('PROVIDER_DISCOVER', 'READ')"
                        type="default"
                        @click="showDiscover = true"
                    >
                        <i class="fa-solid fa-magnifying-glass"></i> Buscar fornecedores
                    </a-button>
                    <a-dropdown :trigger="['click']">
                        <a-button type="default" :loading="exporting">
                            <i class="fa-solid fa-file-export"></i> Exportar <a-icon type="down" />
                        </a-button>
                        <a-menu slot="overlay" @click="handleExport">
                            <a-menu-item key="pdf"><i class="fa-solid fa-print"></i> Imprimir PDF</a-menu-item>
                            <a-menu-item key="excel"><i class="fa-solid fa-file-excel"></i> Exportar Excel</a-menu-item>
                        </a-menu>
                    </a-dropdown>
                    <a-button type="default" @click="showInvitations = true">
                        <i class="fa-solid fa-envelope"></i> Convite
                    </a-button>
                    <a-button type="default" @click="showGroups = true">
                        <i class="fa-solid fa-users"></i> Grupo
                    </a-button>
                    <a-button type="default" :hidden="!isDesktop" @click="$emit('toggle-totalizadores')">
                        <i class="fa-solid fa-calculator"></i>
                        {{ showTotalizadores ? "Ocultar Totalizadores" : "Mostrar Totalizadores" }}
                    </a-button>
                    <a-button type="danger" :hidden="!isDesktop" @click="$emit('limpar')">
                        <i class="fa-solid fa-filter-circle-xmark"></i> Limpar Filtros
                    </a-button>
                    <a-button type="primary" @click="drawerVisible = true">
                        <i class="fa-solid fa-filter"></i> Mais Filtros
                    </a-button>
                </div>
            </template>

            <a-form layout="vertical" style="width: 100%" @submit.prevent="$emit('filtrar')">
                <a-row :gutter="[12, 12]">
                    <a-col :xs="24" :sm="12" :md="8" :lg="6">
                        <a-input
                            v-model="filters.name"
                            placeholder="Buscar por nome"
                            allowClear
                            @pressEnter="$emit('filtrar')"
                        />
                    </a-col>
                    <a-col :xs="24" :sm="12" :md="8" :lg="4">
                        <a-select
                            v-model="filters.status"
                            allowClear
                            placeholder="Status"
                            style="width: 100%"
                            :options="statusOptions"
                        />
                    </a-col>
                    <a-col :xs="24" :sm="12" :md="8" :lg="5">
                        <a-select
                            v-model="filters.state"
                            show-search
                            allowClear
                            placeholder="Estado"
                            style="width: 100%"
                            :options="states"
                            :filterOption="filterOption"
                            :dropdown-style="{ minWidth: '200px' }"
                        />
                    </a-col>
                    <a-col v-if="showProviderFilters" :xs="24" :sm="12" :md="8" :lg="4">
                        <a-select
                            v-model="filters.homologation_status"
                            allowClear
                            placeholder="Homologação"
                            style="width: 100%"
                            :options="homologationOptions"
                        />
                    </a-col>
                    <a-col flex="auto" class="actions-col">
                        <a-form-item class="item-button">
                            <div class="actions-right">
                                <a-button type="default" icon="search" @click="$emit('filtrar')">Filtrar</a-button>
                            </div>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>

            <AdvancedFiltersDrawer :visible.sync="drawerVisible" @apply="$emit('filtrar')" @clear="$emit('limpar')">
                <a-row :gutter="16">
                    <a-col :xs="24">
                        <a-form-item label="Buscar por nome">
                            <a-input
                                v-model="filters.name"
                                placeholder="Nome do fornecedor ou vendedor"
                                allowClear
                                @pressEnter="$emit('filtrar')"
                            />
                        </a-form-item>
                    </a-col>
                    <a-col :xs="24" :md="12">
                        <a-form-item label="Status">
                            <a-select v-model="filters.status" allowClear placeholder="Todos" :options="statusOptions" />
                        </a-form-item>
                    </a-col>
                    <a-col :xs="24" :md="12">
                        <a-form-item label="Estado">
                            <a-select
                                v-model="filters.state"
                                show-search
                                allowClear
                                placeholder="Todos"
                                :options="states"
                                :filterOption="filterOption"
                            />
                        </a-form-item>
                    </a-col>
                    <template v-if="showProviderFilters">
                        <a-col :xs="24" :md="12">
                            <a-form-item label="Homologação">
                                <a-select
                                    v-model="filters.homologation_status"
                                    allowClear
                                    placeholder="Todos"
                                    :options="homologationOptions"
                                />
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :md="12">
                            <a-form-item label="Cidade">
                                <a-input v-model="filters.city" placeholder="Cidade" allowClear @pressEnter="$emit('filtrar')" />
                            </a-form-item>
                        </a-col>
                        <a-col :xs="24" :md="12">
                            <a-form-item label="Telefone">
                                <a-input v-model="filters.phone" placeholder="Telefone" allowClear @pressEnter="$emit('filtrar')" />
                            </a-form-item>
                        </a-col>
                    </template>
                </a-row>
            </AdvancedFiltersDrawer>
        </a-card>

        <AddProviderV2Modal v-if="showAddProvider" @saved="$emit('reload')" @close="showAddProvider = false" />
        <InvitationsV2Modal v-if="showInvitations" @load_sellers="$emit('reload')" @close="showInvitations = false" />
        <SellerGroupsV2Modal v-if="showGroups" @close="showGroups = false" />
        <DiscoverProvidersV2Modal v-if="showDiscover" @linked="$emit('reload')" @close="showDiscover = false" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import ProviderServiceV3 from "@/services/v3/provider.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import ExcelDownload from "@/services/ExcelDownload.js";
import AdvancedFiltersDrawer from "@/components/cliente/monitors/AdvancedFiltersDrawer.vue";
import AddProviderV2Modal from "./modals/add-provider-v2.modal.vue";
import InvitationsV2Modal from "./modals/invitations-v2.modal.vue";
import SellerGroupsV2Modal from "./modals/seller-groups-v2.modal.vue";
import DiscoverProvidersV2Modal from "@/modals/discover-providers-v2.modal.vue";
import { perm_mixin } from "@/mixins/permission.mixin";

export default {
    name: "SellersHeaderV2",
    mixins: [perm_mixin],
    components: {
        AdvancedFiltersDrawer,
        AddProviderV2Modal,
        InvitationsV2Modal,
        SellerGroupsV2Modal,
        DiscoverProvidersV2Modal,
    },
    props: {
        title: { type: String, required: true },
        subtitle: { type: String, default: "" },
        filters: { type: Object, required: true },
        appliedFilters: { type: Object, required: true },
        states: { type: Array, default: () => [] },
        isDesktop: { type: Boolean, default: true },
        showTotalizadores: { type: Boolean, default: true },
        showProviderFilters: { type: Boolean, default: false },
    },
    data() {
        return {
            svc: new ProviderServiceV3(),
            drawerVisible: false,
            exporting: false,
            showAddProvider: false,
            showInvitations: false,
            showGroups: false,
            showDiscover: false,
            statusOptions: [
                { value: "ACTIVE", label: "Ativos" },
                { value: "BLOCKED", label: "Bloqueados" },
            ],
            homologationOptions: [
                { value: "HOMOLOGATED", label: "Homologados" },
                { value: "PENDING", label: "Pendentes" },
                { value: "REFUSED", label: "Recusados" },
                { value: "PARTIAL", label: "Parciais" },
            ],
        };
    },
    computed: {
        ...mapState(["whitelabel"]),
    },
    methods: {
        filterOption(input, option) {
            const label = option.componentOptions.children[0].text || "";
            return label.toLowerCase().includes(input.toLowerCase());
        },
        handleExport({ key }) {
            if (key === "pdf") this.printSellers();
            else if (key === "excel") this.exportExcel();
        },
        fetchExportSellers() {
            this.exporting = true;
            return this.svc
                .load({
                    page: 1,
                    page_size: 1000,
                    name: this.appliedFilters.name,
                    status: this.appliedFilters.status || null,
                    state: this.appliedFilters.state || null,
                })
                .then(({ data }) => data.data || [])
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                    return null;
                })
                .finally(() => {
                    this.exporting = false;
                });
        },
        stateName(provider) {
            return provider.head_office && provider.head_office.state ? provider.head_office.state.name : "--";
        },
        cityName(provider) {
            return provider.head_office && provider.head_office.city ? provider.head_office.city.name : "--";
        },
        isBlocked(provider) {
            return !!(provider.blacklists && provider.blacklists.length);
        },
        exportExcel() {
            this.fetchExportSellers().then((sellers) => {
                if (!sellers) return;
                new ExcelDownload({
                    tableName: "Fornecedores",
                    userName: localStorage.getItem("user_name"),
                    store: localStorage.getItem("grupo"),
                    author: this.whitelabel?.data.providers.text_window,
                    headerColor: this.whitelabel?.data.colors.primary,
                    header: ["id", "Fornecedor", "CNPJ", "Estado", "Cidade", "Telefone", "Vendedor", "Tel. vendedor", "Email", "Status"],
                    body: sellers.map((value) => [
                        String(value.id),
                        value.provider.name,
                        value.provider.cnpj,
                        this.stateName(value.provider),
                        this.cityName(value.provider),
                        value.provider.phone || "--",
                        value.name,
                        value.phone || "--",
                        value.email,
                        this.isBlocked(value.provider) ? "bloqueado" : "ativo",
                    ]),
                });
            });
        },
        escapeHtml(value) {
            return String(value == null ? "" : value)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
        },
        printSellers() {
            this.fetchExportSellers().then((sellers) => {
                if (!sellers) return;
                const e = this.escapeHtml;
                const logo = this.whitelabel ? this.whitelabel.data.imgs.img_logo : require("@/assets/Logo-BRANCA.svg");
                const rows = sellers
                    .map(
                        (s) =>
                            `<tr><td>${e(s.provider.name)}<br/>${e(s.provider.cnpj)}</td>` +
                            `<td>${e(s.name)}<br/>${e(s.phone || "--")}</td>` +
                            `<td>${e(this.stateName(s.provider))}</td>` +
                            `<td>${e(this.cityName(s.provider))}</td>` +
                            `<td>${this.isBlocked(s.provider) ? "Bloqueado" : "Ativado"}</td></tr>`
                    )
                    .join("");
                const html =
                    "<html><head><title>Meus Fornecedores</title><style>" +
                    "body{font-family:Arial,sans-serif;margin:20px;font-size:12px}" +
                    "img{width:12rem}h2{margin:12px 0}" +
                    "table{width:100%;border-collapse:collapse}" +
                    "th,td{border-bottom:1px solid #ccc;padding:6px;text-align:left;vertical-align:top}" +
                    "</style></head><body>" +
                    `<img src="${logo}"/><h2>Meus Fornecedores</h2>` +
                    "<table><thead><tr><th>Empresa / CNPJ</th><th>Vendedor / Telefone</th><th>Estado</th><th>Cidade</th><th>Status</th></tr></thead>" +
                    `<tbody>${rows}</tbody></table></body></html>`;

                const iframe = document.createElement("iframe");
                iframe.style.position = "fixed";
                iframe.style.width = "0";
                iframe.style.height = "0";
                iframe.style.border = "none";
                document.body.appendChild(iframe);
                const doc = iframe.contentDocument || iframe.contentWindow.document;
                doc.open();
                doc.write(html);
                doc.close();
                setTimeout(() => {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                    setTimeout(() => document.body.removeChild(iframe), 1000);
                }, 500);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/sass/commons/_list-page-v2";
</style>
